
<template>
  <div>
    <div class="orderMain">
      <el-tabs type="border-card" @tab-click="changetab" v-model="tabCard">
        <el-tab-pane label="订单列表" name="orderTypes">
          <div class="mb15">
            <span>订单类型：</span>
            <el-select
              size="small"
              v-model="formInline.orderStatus"
              @change="allPageFormInlineChange"
            >
              <el-option
                v-for="item in orderSelectData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <el-form :inline="true" :model="formInline" ref="ruleForm">
            <el-form-item label="订单编号：" prop="orderNumber">
              <el-select
                clearable
                size="small"
                v-model="formInline.orderNumber"
                filterable
                remote
                placeholder="请输入订单编号"
                :remote-method="remoteOrderNumber"
                :loading="loading1"
                @change="searchOrderNumber"
              >
                <el-option
                  v-for="item in orderNumberList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="会员姓名或电话：" prop="queryMember">
              <el-select
                clearable
                size="small"
                v-model="formInline.queryMember"
                filterable
                remote
                placeholder="请输入会员姓名或电话"
                :remote-method="remoteMember"
                :loading="loading2"
                @change="searchMember"
              >
                <el-option
                  v-for="item in memberList"
                  :key="item.value"
                  :label="item.title"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建人：" prop="createUser">
              <el-select
                clearable
                size="small"
                v-model="formInline.createUser"
                placeholder="请选择创建人"
                @change="allPageFormInlineChange"
              >
                <el-option
                  v-for="item in createUserList"
                  :key="item.userId"
                  :label="item.realname"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="门店："
              v-if="sessionStorageTypeNameTrue"
              prop="shopId"
            >
              <el-select
                filterable
                clearable
                v-model="formInline.shopId"
                size="small"
                placeholder="请选择门店"
                @change="allPageFormInlineChange"
              >
                <el-option
                  v-for="item in mdSelectList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单日期：">
              <el-date-picker
                v-model="DateParameter"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                size="small"
                @change="dateChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="reset" type="primary"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
          <div class="flex">
            <div class="orderTotle">订单数：{{ orderTotle }}</div>
            <el-button
              type="primary"
              @click="openCreateOrderDialog"
              size="small"
              class="btnClass"
            >
              创建订单
            </el-button>
          </div>
          <el-table :data="orderData" :row-class-name="tableRowClassName">
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="orderNumber" label="订单编号" align="center">
            </el-table-column>
            <el-table-column prop="memberName" label="会员" align="center">
              <template slot-scope="scope">
                <div class="colorBlue" @click="openMember(scope.row)">
                  {{ scope.row.memberName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="memberMobile"
              label="会员电话"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="shopName" label="门店" align="center">
            </el-table-column>
            <el-table-column prop="createUser" label="创建人" align="center">
              <template slot-scope="scope">
                <div class="colorBlue">
                  {{ scope.row.createUser }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="numberOfShoppers"
              label="进店人数"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="antOrderMiscellaneousList"
              label="费用名"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-for="item in scope.row.antOrderMiscellaneousList"
                  :key="item.id"
                  class="underline"
                >
                  {{ item.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="antOrderMiscellaneousList"
              label="金额"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-for="item in scope.row.antOrderMiscellaneousList"
                  :key="item.id"
                  class="underline colorRed"
                >
                  {{ item.money }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="totalMoney" label="总金额" align="center">
              <template slot-scope="scope">
                <div class="colorRed">
                  {{ scope.row.totalMoney }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="actualAmount" label="实收" align="center">
            </el-table-column>
            <el-table-column prop="createDate" label="创建时间" align="center">
            </el-table-column>
            <el-table-column prop="updateDate" label="修改时间" align="center">
            </el-table-column>
            <el-table-column
              prop="orderStatusName"
              label="订单类型"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="remarks" label="备注" align="center">
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="center">
              <template slot-scope="scope">
                <div
                  v-show="
                    scope.row.orderStatus != '0' && scope.row.orderStatus != '9'
                  "
                >
                  <el-button
                    @click="openOrderDetails(scope.row)"
                    type="text"
                    size="small"
                  >
                    订单详情
                  </el-button>
                </div>
                <div v-show="scope.row.orderStatus != '9'">
                  <el-button
                    type="text"
                    size="small"
                    @click="openGradeInDialog(scope.row)"
                  >
                    成绩录入
                  </el-button>
                </div>
                <div v-show="scope.row.orderStatus != '9'">
                  <el-button
                    type="text"
                    size="small"
                    @click="openPkInDialog(scope.row)"
                  >
                    比赛录入
                  </el-button>
                </div>
                <div v-show="scope.row.orderStatus == '0'">
                  <el-button
                    type="text"
                    size="small"
                    @click="openOrderOverDialog(scope.row)"
                  >
                    订单结算
                  </el-button>
                </div>
                <div v-show="scope.row.orderStatus == '0'">
                  <el-button
                    type="text"
                    size="small"
                    @click="openCancelOrderDialog(scope.row)"
                  >
                    取消订单
                  </el-button>
                </div>
                <div v-show="scope.row.orderStatus == '1'">
                  <el-button
                    type="text"
                    size="small"
                    @click="delorder(scope.row)"
                  >
                    删除订单
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pageClass"
            @current-change="otCurrentChange"
            @size-change="handleSizeChange"
            layout="total,prev, pager,next,sizes"
            :current-page.sync="orderDataObj.current"
            :page-size="orderDataObj.size"
            :total="orderDataObj.total"
            :page-sizes="[10, 20, 30, 40, 50]"
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="储物寄存" name="storageName"> </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 创建订单 -->
    <el-dialog
      :visible.sync="createOrderDialog"
      width="40%"
      :before-close="createOrderDialogClose"
      :close-on-click-modal="false"
    >
      <div class="flexTitle">
        <h5>创建订单</h5>
        <h5>创建时间：{{ createDateNow }}</h5>
      </div>
      <div class="positionR">
        <el-form
          class="width70"
          label-width="100px"
          :model="createOrderFrom"
          :rules="createOrderrules"
          ref="createOrderFrom"
        >
          <el-form-item label="搜索会员：" prop="memberId">
            <el-select
              v-model="createOrderFrom.memberId"
              filterable
              remote
              placeholder="请输入会员名称/电话"
              :remote-method="remoteMethod"
              :loading="loading"
              @change="pitchMember"
            >
              <el-option
                v-for="item in dimMemberList"
                :key="item.value"
                :label="item.title"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会员名称：" prop="memberName">
            <el-input
              v-model="createOrderFrom.memberName"
              placeholder="会员名称"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员电话：" prop="memberPhone">
            <el-input
              v-model="createOrderFrom.memberPhone"
              placeholder="会员电话"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="归属门店：" prop="shopName">
            <el-input
              v-model="createOrderFrom.shopName"
              placeholder="归属门店"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="归属教练：" prop="createUserName">
            <el-input
              v-model="createOrderFrom.createUserName"
              placeholder="归属教练"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员荣誉：" prop="editHonours">
            <el-checkbox-group v-model="createOrderFrom.editHonours">
              <el-checkbox-button
                v-for="item in vipHonor"
                :label="item.id"
                :key="item.id"
                >{{ item.honourName }}
              </el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="创建人：" prop="createUser">
            <el-select
              v-model="createOrderFrom.createUser"
              placeholder="请选择创建人"
            >
              <el-option
                v-for="item in createUserList"
                :key="item.userId"
                :label="item.realname"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="进店人数：" prop="numberOfShoppers">
            <el-input
              v-model="createOrderFrom.numberOfShoppers"
              placeholder="请输入进店人数"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="oederManPhoto">
          <img
            v-if="createOrderFrom.photoData"
            :src="globelurls + createOrderFrom.photoData"
            alt=""
          />
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="openCreateVipDialog('create')"
          >新建会员</el-button
        >
        <el-button type="primary" @click="addOrders">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 取消订单 -->
    <el-dialog
      title="取消订单"
      :visible.sync="cancelOrderDialog"
      width="30%"
      :before-close="cancelOrderDialogClose"
      :close-on-click-modal="false"
    >
      <el-input v-model="cancelReason" placeholder="请输入取消原因"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelOrder">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 订单结算 -->
    <el-dialog
      :visible.sync="orderOverDialog"
      width="40%"
      :before-close="orderOverDialogClose"
      :close-on-click-modal="false"
    >
      <div class="flexTitle">
        <h5>订单结算</h5>
        <h5>结算时间：{{ createDateNow }}</h5>
      </div>
      <div class="flex borderB">
        <div class="left">
          <div class="mb15">订单编号：{{ memberInfo.orderNumber }}</div>
          <div class="mb15">
            <span>
              会员名称：{{ memberInfo.memberName }}
              <b v-if="memberInfo.newOldMemberLogo == 1" style="color: red"
                >(老资费)</b
              >
            </span>
            <span class="ml20"> 会员电话：{{ memberInfo.memberMobile }}</span>
          </div>
          <div class="mb15">
            <span>会员等级：{{ memberInfo.memberLevelName }}</span>
            <el-button
              type="text"
              class="ml20"
              @click="openCreateVipDialog('up')"
            >
              升卡储值</el-button
            >
          </div>
          <div class="mb15">会员积分：{{ memberInfo.memberPoints }}</div>
        </div>
        <div class="right" v-if="memberInfo.photoPath">
          <img :src="globelurls + memberInfo.photoPath" alt="" />
        </div>
      </div>
      <!--  进店人数-->
      <div class="borderB mt10">
        <div class="mb15">
          <h6 class="mb15">进店人数</h6>
          <div class="inMan">
            <span style="margin-right：10px">进店人数：</span>
            <el-input
              v-model="memberInfo.numberOfShoppers"
              size="mini"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
            <span class="ml5">人</span>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="borderB mt10">
        <div class="mb15">
          <h6 class="mb15">基本费用</h6>
          <div class="mb15">
            射箭组数：<el-input-number
              v-model="memberInfo.archeryNumber"
              size="mini"
              :min="0"
              :precision="0"
              :step="1"
              step-strictly
            ></el-input-number>
          </div>
          <div class="mb15">
            随行组数：<el-input-number
              v-model="memberInfo.followArcheryNumber"
              size="mini"
              :min="0"
              :precision="0"
              :step="1"
              step-strictly
            ></el-input-number>
          </div>
        </div>
      </div>
      <div class="borderB mt10">
        <div class="ortherClass">
          <h6 class="">其他费用</h6>
          <el-button
            size="mini"
            class="addOther"
            type="primary"
            icon="el-icon-plus"
            @click="openAddOtherDialog"
            >添加</el-button
          >
        </div>
        <el-form :model="memberInfo" label-width="100px" class="width70">
          <div
            v-if="
              memberInfo.antOrderTempList &&
              memberInfo.antOrderTempList.length > 0
            "
          >
            <div v-for="item in memberInfo.antOrderTempList" :key="item.name">
              <el-form-item
                :label="item.name"
                v-if="
                  item.dictKey == 'drinks' ||
                  (upgradeCardFlag && item.dictKey == 'upgrade_card') ||
                  (upgradeCardFlag && item.dictKey == 'stored_value') ||
                  item.dictKey == 'settlementNotByMembershipLevel'
                "
              >
                <div class="disflexOne">
                  <el-input
                    style="width: 100px"
                    v-model="item.money"
                    size="mini"
                    :disabled="
                      item.dictKey == 'upgrade_card' ||
                      item.dictKey == 'stored_value'
                    "
                    @input="hah"
                    onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                  ></el-input>
                  <!-- onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                    onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" -->
                  <span class="ml5">元</span>
                  <span
                    v-if="item.dictKey == 'upgrade_card'"
                    class="ml20 colorRed width50"
                    >{{ upafter }}</span
                  >
                  <div
                    class="remaaaaa"
                    v-if="
                      item.dictKey != 'upgrade_card' &&
                      item.dictKey != 'stored_value'
                    "
                  >
                    备注:
                  </div>
                  <el-input
                    v-model="item.remarks"
                    size="mini"
                    v-if="
                      item.dictKey != 'upgrade_card' &&
                      item.dictKey != 'stored_value'
                    "
                  ></el-input>
                </div>
              </el-form-item>
            </div>
          </div>
          <div
            v-if="
              memberInfo.antOrderMiscellaneousList &&
              memberInfo.antOrderMiscellaneousList.length > 0
            "
          >
            <div
              v-for="item in memberInfo.antOrderMiscellaneousList"
              :key="item.name"
            >
              <el-form-item :label="item.name">
                <div class="disflexOne">
                  <el-input
                    style="width: 100px"
                    v-model="item.money"
                    size="mini"
                    :disabled="
                      item.dictKey == 'upgrade_card' ||
                      item.dictKey == 'stored_value'
                    "
                    onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                  >
                  </el-input>
                  <span class="ml5">元</span>
                  <span v-if="item.name == '升卡'" class="ml20">{{
                    upafter
                  }}</span>
                  <i
                    class="el-icon-remove ml10 colorRed iconClass"
                    v-if="
                      showSubtraction &&
                      item.dictKey != 'upgrade_card' &&
                      item.dictKey != 'stored_value' &&
                      item.dictKey != 'drinks' &&
                      item.dictKey != 'settlementNotByMembershipLevel'
                    "
                    @click="remoteOther(item)"
                  ></i>
                  <div
                    class="remaaaaa"
                    v-if="
                      item.dictKey != 'upgrade_card' &&
                      item.dictKey != 'stored_value'
                    "
                  >
                    备注:
                  </div>
                  <el-input
                    v-model="item.remarks"
                    size="mini"
                    v-if="
                      item.dictKey != 'upgrade_card' &&
                      item.dictKey != 'stored_value'
                    "
                  ></el-input>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="borderB">
        <h6>订单备注：</h6>
        <el-input
          type="textarea"
          v-model="memberInfo.remarks"
          class="mb15"
        ></el-input>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="openOrderOverDetailsDialog"
          >结算</el-button
        >
        <el-button type="primary" @click="addOrderDetails">保存</el-button>
      </span>
    </el-dialog>
    <!-- 添加其他费用 -->
    <el-dialog
      :visible.sync="addOtherDialog"
      width="30%"
      :before-close="addOtherDialogClose"
      :close-on-click-modal="false"
    >
      <div class="mb15">添加其他费用</div>
      <div class="checkBox">
        <div v-for="item in check" :key="item.id">
          <el-checkbox
            :label="item.name"
            :key="item.id"
            v-model="item.checked"
          ></el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="melfDialog">确定</el-button>
      </span>
    </el-dialog>
    <!-- 订单结算详情 -->
    <el-dialog
      title="订单结算详情"
      :visible.sync="orderOverDetailsDialog"
      width="55%"
      :before-close="orderOverDetailsDialogClose"
      :close-on-click-modal="false"
    >
      <div class="underline mb15">
        <div class="fz">
          <span
            >订单编号：<span class="ml20">{{
              closeMoney.orderNumber
            }}</span></span
          >
          <!-- <span class="ml20">
            射箭组数：<span>{{ memberInfo.archeryNumber }}</span></span
          >
          <span class="ml20">
            随行组数：<span>{{ memberInfo.followArcheryNumber }}</span></span
          >
          <span class="ml20">
            会员单价：<span>{{ memberInfo.levelPrice }}</span></span
          >
          <span class="ml20">
            随行单价：<span>{{ memberInfo.followPrice }}</span></span
          > -->
        </div>
        <div class="mb15">
          总计金额：<span class="ml20">{{ closeMoney.totalMoney }}元</span
          ><i class="el-icon-arrow-down ml5" @click="disbchange" v-if="disb"></i
          ><i class="el-icon-arrow-up ml5" @click="disbchange" v-if="!disb"></i>
        </div>
        <div v-if="disb" class="ml45 mb15">
          <div
            v-for="(item, index) in closeMoney.antOrderMiscellaneousList"
            :key="index"
          >
            {{ item.name }}：<span class="ml15">{{ item.money }}元</span>
          </div>
          <div>
            射箭：<span class="ml15">
              {{
                closeMoney.archeryPriceTotal ? closeMoney.archeryPriceTotal : 0
              }}元</span
            >
          </div>
          <div>
            随行：<span class="ml15">
              {{
                closeMoney.followPriceTotal ? closeMoney.followPriceTotal : 0
              }}元</span
            >
          </div>
        </div>
        <div class="mb15">
          会员抵扣：<span class="ml20"
            ><span v-if="closeMoney.realityMoney">-</span
            >{{ closeMoney.realityMoney }}</span
          >
        </div>
        <div class="mb15">
          <!-- 应结算：<span class="ml20">{{
            closeMoney.residue ? closeMoney.residue.toFixed(2) : 0
          }}</span> -->
          应结算：<span class="ml20">{{ closeMoney.residue }}</span>
        </div>
      </div>
      <div class="underline mb15">
        <div class="mb15">
          会员信息
          <b style="color: red"
            >{{ closeMoney.newOldMemberLogo == 1 ? "(老资费)" : "" }}
          </b>
        </div>
        <div class="vipclearing">
          <div>
            {{ closeMoney.memberLevelName }}
          </div>
          <div class="clearingBox">
            <div>
              <span>积分：</span
              ><span>{{
                closeMoney.memberPoints ? closeMoney.memberPoints : 0
              }}</span>
            </div>
            <div>
              <span>储值：</span
              ><span>{{ closeMoney.balance ? closeMoney.balance : 0 }}</span>
            </div>
            <div>
              <span>箭票：</span
              ><span>{{
                closeMoney.arrowVolume ? closeMoney.arrowVolume : 0
              }}</span>
            </div>
            <div>
              <span>能量值：</span
              ><span>{{ closeMoney.power ? closeMoney.power : 0 }}</span>
            </div>
            <div>
              <span>赠储：</span
              ><span>{{
                closeMoney.giveStore ? closeMoney.giveStore : 0
              }}</span>
            </div>
            <div>
              <span>电子卡：</span
              ><span>{{
                closeMoney.electronicCard ? closeMoney.electronicCard : 0
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="underline mb15">
        <div class="mb15">箭票射箭</div>
        <div class="clearingBoxs mb15">
          <div v-for="item in arrowPaymentMethodList" :key="item.text">
            <span class="needwidth1">{{ item.text }}</span>
            <el-input-number
              size="mini"
              v-model="item.payMoney"
              @change="
                (currentValue, oldValue) =>
                  changeMoey(currentValue, oldValue, item)
              "
              :disabled="
                (item.paymentMethod == 'arrow_ticket' && disjianpiao) ||
                (item.paymentMethod == 'electronic_card' && discard) ||
                (item.paymentMethod == 'have_great_arrow_ticket' &&
                  disyouzanjianpiao) ||
                (item.paymentMethod == 'paper_arrow_ticket' &&
                  diszhizhijianpiao) ||
                (item.paymentMethod == 'have_great_electronic_card' &&
                  disyouzancard)
              "
              :min="0"
              :max="item.max"
            ></el-input-number>
            <span class="ml5">组</span>
          </div>
        </div>
        <div class="mb15">储值射箭</div>
        <div class="clearingBoxs mb15">
          <div v-for="(item, index) in storedPaymentMethodList" :key="index">
            <span class="needwidth">{{ item.text }}</span>
            <!-- {{item.max}} -->
            <el-input-number
              size="mini"
              v-model="item.payMoney"
              @change="
                (currentValue, oldValue) =>
                  changeMoey(currentValue, oldValue, item)
              "
              :disabled="
                (item.paymentMethod == 'balance_consume' && disstoredValue) ||
                (item.paymentMethod == 'follow_balance_consume' &&
                  disstoredValue) ||
                (item.paymentMethod == 'give_store_consume' && disgive) ||
                (item.paymentMethod == 'follow_give_store_consume' &&
                  disgive) ||
                (item.paymentMethod == 'drinks_consume' && disdrinks)
              "
              :min="0"
              :max="item.max"
            ></el-input-number>
            <!-- :step="item.text == '饮料消费' ? 0.1 : 1" -->
            <span v-if="item.paymentMethod != 'drinks_consume'" class="ml5"
              >组</span
            >
            <span v-if="item.paymentMethod == 'drinks_consume'" class="ml5"
              >元</span
            >
          </div>
        </div>
        <!--  -->
        <div class="mb15">储值赠储消费</div>
        <div class="disflexOne mb15">
          <div
            v-for="item in otherArr"
            :key="item.paymentMethod"
            class="disflexOne ml20"
          >
            <div class="">{{ item.text }}</div>
            <div class="inputbox disflexOne">
              <el-input
                size="mini"
                v-model="item.payMoney"
                @input="inputOtherArr"
                onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
              >
                <!--     onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')" baidu -->
                <!--  onkeyup="item.payMoney=item.payMoney.replace(/^\d+(.\d{1,2})?$/)" xie --> </el-input
              ><span class="ml5">元</span>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
      <div>
        <div class="mb15 flexOney">
          <div>结算方式</div>
          <!-- closeMoney.residue?(closeMoney.residue).toFixed(2):0 -->
          <div class="ml20">
            合计：{{ otherPay ? otherPay.toFixed(2) : 0 }}元
          </div>
        </div>
        <div class="disFWrap">
          <div
            v-for="item in otherPaymentMethodList"
            :key="item.text"
            class="disF mb15"
          >
            <div class="tags">{{ item.text }}</div>
            <div class="inputbox">
              <el-input
                size="mini"
                v-model="item.payMoney"
                @input="onChangeMoney"
              ></el-input
              ><span class="ml5">元</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderOverDetailsDialogClose">上一步</el-button>
        <el-button
          type="primary"
          @click="orderOverDetailsDialogCloses"
          :disabled="disabledClose"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新建会员 -->
    <createVipDialog
      v-model="createVipDialog"
      :createOrUp="createOrUp"
      :memberId="memberId"
      :huixian="huixian"
      @input="input"
      @prices="prices"
    ></createVipDialog>
    <!-- 订单详情 -->
    <orderOverDetails
      v-model="orderDetails"
      :orderId="orderId"
    ></orderOverDetails>
    <!-- 成绩录入 -->
    <gradeIn
      v-model="gradeInDialog"
      :memberId="memberId"
      :orderId="orderId"
      :memberPoints="memberPoints"
      @inputGradeInClose="inputGradeInClose"
    ></gradeIn>
    <!-- 比赛录入 -->
    <pkIn
      v-model="pkInDialog"
      :memberId="memberId"
      :orderId="orderId"
      @pkInDialogClose="pkInDialogClose"
    ></pkIn>
    <!-- 会员详情 -->
    <memberInfo
      v-model="gopenMemberDialog"
      :memberId="gopenMemberDialogmemberId"
      @gopenMemberDialogClose="gopenMemberDialogClose"
    ></memberInfo>
  </div>
</template>
<script>
import { dateNow, dateNowYear } from "../../utils/util";
import createVipDialog from "../components/Vipdialog.vue";
import orderOverDetails from "../components/orderOverDetails.vue";
import pkIn from "../components/pkIn.vue";
import gradeIn from "../components/gradeIn.vue";
import { globelurl } from "../../api/axios";
import {
  getOrderList,
  getMembersInfo, //创建订单-模糊下拉
  getUserForSelect, //创建订单-创建人下拉
  getMemberById, //创建订单-获取会员详情
  addOrder, //创建订单
  cancelOrder, //取消订单
  addOrderDetails, //保存订单详情
  getOrderDetail, //订单详情
  getsettlementReturnsBillingInformation, // 结算返回结算信息
  confirmPayment, //结算
  getOrderNumberList, //订单编号模糊查询
  getOrderCustomizationList, //订单自定义项列表
  delorder, //删除订单
} from "@/api/OrderManagement.js";
import {
  getMembersCardLevelSelect,
  getAntDeptSelect,
  getHonourList,
} from "../../api/BusinessManagement";
import memberInfo from "../components/memberInfo.vue";
export default {
  name: "OrderManager",
  components: {
    createVipDialog,
    orderOverDetails,
    gradeIn,
    pkIn,
    memberInfo,
  },
  data() {
    return {
      tabCard: "orderTypes",
      orderSelectData: [
        {
          value: "",
          label: "全部订单",
        },
        {
          value: "0",
          label: "未结算订单",
        },
        {
          value: "1",
          label: "已结算订单",
        },
        {
          value: "9",
          label: "取消订单",
        },
      ],
      formInline: {
        orderStatus: "",
        orderNumber: "",
        queryMember: "",
        createUser: "",
        startDate: "",
        endDate: "",
        pageNo: 1,
        pageSize: 10,
        shopId: "",
      },
      DateParameter: [],
      loading1: false,
      orderNumberList: [],
      loading2: false,
      memberList: [],
      createUserList: [],
      orderTotle: 0,
      orderData: [],
      queryMemberTemp: "",
      parmsTemp: null,
      createOrderDialog: false,
      createDateNow: "", //创建时间
      createOrderFrom: {
        //创建订单表单
        memberId: "",
        memberName: "",
        memberPhone: "",
        createUser: "",
        createUserName: "",
        shopName: "",
        editHonours: [],
        numberOfShoppers: "1",
        photoData: "",
      },
      createOrderrules: {
        memberId: [{ required: true, message: "请搜索会员" }],
        createUser: [{ required: true, message: "请选择创建人" }],
      },
      loading: false,
      dimMemberList: [], //会员模糊option
      globelurls: globelurl,
      createOrUp: "", //子组件弹窗title值
      createVipDialog: false, //创建会员弹窗
      cancelOrderDialog: false, //取消订单弹窗
      cancelReason: "", //订单取消原因
      orderId: "", //订单id
      orderDetails: false, //订单详情弹窗开关
      orderOverDialog: false,
      upgradeCardFlag: false,
      showSubtraction: false, //是否展示删除按钮
      addOtherDialog: false, //添加其他费用弹窗
      check: [
        // {
        //   checked: false,
        //   name: "器材",
        // },
        // {
        //   checked: false,
        //   name: "寄存",
        // },
        // {
        //   checked: false,
        //   name: "售后",
        // },
        // {
        //   checked: false,
        //   name: "收押金",
        // },
        // {
        //   checked: false,
        //   name: "退款",
        // },
      ],
      upafter: "", //回显升卡后会员名
      drinkMoney: "", //饮料花费
      memberId: "", //会员id
      memberInfo: {},
      specialItem: [
        {
          dictKey: "upgrade_card",
          name: "升卡",
          money: "",
          upgradeLevelId: "",
          remarks: "",
        },
        {
          dictKey: "stored_value",
          name: "储值",
          money: "",
          remarks: "",
        },
        {
          dictKey: "drinks",
          name: "饮料",
          money: "",
          remarks: "",
        },
        {
          dictKey: "settlementNotByMembershipLevel",
          name: "储赠扣款",
          money: "",
          remarks: "",
        },
      ],
      closeMoney: {},
      orderOverDetailsDialog: false,
      disb: false,
      arrowPaymentMethodList: [
        //箭票射箭
        {
          payMoney: "",
          text: "箭票",
          paymentMethod: "arrow_ticket",
          type: "arrowVolume",
          max: 0,
        },
        {
          payMoney: "",
          text: "有赞箭票",
          paymentMethod: "have_great_arrow_ticket",
          type: "none",
          max: 0,
        },
        {
          payMoney: "",
          text: "纸质箭票",
          paymentMethod: "paper_arrow_ticket",
          type: "none",
          max: 0,
        },
        {
          payMoney: "",
          text: "电子卡",
          paymentMethod: "electronic_card",
          type: "electronicCard",
          max: 0,
        },
        {
          payMoney: "",
          text: "有赞电子卡",
          paymentMethod: "have_great_electronic_card",
          type: "none",
          max: 0,
        },
      ],

      storedPaymentMethodList: [
        //储值射箭
        {
          payMoney: "",
          text: "储值消费",
          paymentMethod: "balance_consume",
          max: 0,
        },
        {
          payMoney: "",
          text: "赠储消费",
          paymentMethod: "give_store_consume",
          max: 0,
        },
        {
          payMoney: "",
          text: "饮料消费",
          paymentMethod: "drinks_consume",
          max: 0,
        },
        {
          payMoney: "",
          text: "随行储值消费",
          paymentMethod: "follow_balance_consume",
          max: 0,
        },
        {
          payMoney: "",
          text: "随行赠储消费",
          paymentMethod: "follow_give_store_consume",
          max: 0,
        },
      ],
      otherPaymentMethodList: [
        //支付方式
        {
          payMoney: "",
          text: "现金",
          paymentMethod: "cash_consume",
        },
        {
          payMoney: "",
          text: "刷卡",
          paymentMethod: "slot_card_consume",
        },
        {
          payMoney: "",
          text: "微信",
          paymentMethod: "wechat_consume",
        },
        {
          payMoney: "",
          text: "团购",
          paymentMethod: "group_buying_consume",
        },
        {
          payMoney: "",
          text: "支付宝",
          paymentMethod: "alipay_consume",
        },
        {
          payMoney: "",
          text: "减免",
          paymentMethod: "derate_consume",
        },
      ],
      orderDataObj: {},
      playAll: 0, //抵扣总数（组）
      playNum: 0, //射箭总组数（组）
      disjianpiao: false, //箭票禁用
      discard: false, //电子卡禁用
      disstoredValue: false, //储值禁用
      disgive: false, //赠储禁用
      drinksmoney: 0, //饮料消费金额
      disdrinks: true, //饮料禁用
      disyouzanjianpiao: false, //有赞箭票禁用
      diszhizhijianpiao: false, //纸质箭票禁用
      disyouzancard: false, //有赞电子卡禁用
      havedrink: false, //是否有饮料消费
      gradeInDialog: false, //成绩录入弹窗
      pkInDialog: false, //比赛录入弹窗
      memberPoints: "", //会员积分
      huixian: [],
      changeDrinkMoney: "", //饮料input的值
      otherPay: 0, //合计
      mdSelectList: [], //门店下拉
      sessionStorageTypeNameTrue: false, //是否显示门店
      disabledClose: false, //订单结算确定按钮
      vipHonor: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      gopenMemberDialogmemberId: "",
      gopenMemberDialog: false,
      otherArr: [
        {
          payMoney: "",
          text: "储值结算",
          paymentMethod: "balance_consume_not_level",
        },
        {
          payMoney: "",
          text: "赠储结算",
          paymentMethod: "giveStore_consume_not_level",
        },
      ],
      chuzhiandzengchu: 0,
      xx: 0,
    };
  },

  mounted() {
    this.getUserForSelect();
    this.dateNowYearPage();
    this.getOrderList();
    this.getOrderCustomizationList();
    this.getAntDeptSelect();
    this.sessionStorageType();
  },
  methods: {
    changetab(tab) {
      if (tab.label == "储物寄存") {
        this.$router.push("/OrderManagement/storageRegister");
      }
    },
    tableRowClassName({ row }) {
      if (row.orderStatus == "1") {
        return "success-row";
      } else if (row.orderStatus == "9") {
        return "cancel-row";
      }
    },
    // 管理员 运营 财务 可以筛选门店
    sessionStorageType() {
      const showShop = sessionStorage.roleCode;
      if (
        showShop == "management" ||
        showShop == "operation" ||
        showShop == "financing"
      ) {
        this.sessionStorageTypeNameTrue = true;
      } else {
        this.sessionStorageTypeNameTrue = false;
      }
    },
    // 创建人下拉框
    getUserForSelect() {
      getUserForSelect({ shopId: sessionStorage.shopId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.createUserList = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.mdSelectList = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    allPageFormInlineChange() {
      this.formInline.pageNo = 1;
      this.getOrderList();
    },
    // 订单编号模糊查询
    remoteOrderNumber(query) {
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.loading1 = false;
          getOrderNumberList({ orderNumber: query }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.orderNumberList = res.data.result;
            }
          });
        }, 200);
      } else {
        this.orderNumberList = [];
      }
    },
    // 订单编号模糊查询确定
    searchOrderNumber() {
      this.allPageFormInlineChange();
      this.orderNumberList = [];
    },
    // 会员姓名电话模糊查询
    remoteMember(query) {
      if (query !== "") {
        this.loading2 = true;
        setTimeout(() => {
          this.loading2 = false;
          getMembersInfo({ queryValue: query }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.memberList = res.data.result;
            }
          });
        }, 200);
      } else {
        this.memberList = [];
      }
    },
    // 会员姓名电话模糊查询确定
    searchMember() {
      if (this.formInline.queryMember) {
        getMemberById({ id: this.formInline.queryMember }).then((res) => {
          if (res.status === 200 && res.data.success) {
            this.queryMemberTemp = res.data.result.memberMobile;
            this.allPageFormInlineChange();
            this.memberList = [];
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.allPageFormInlineChange();
      }
    },
    // 日期选中修改
    dateChange() {
      if (this.DateParameter && this.DateParameter.length > 0) {
        this.DateParameter = [
          this.DateParameter[0] + " " + "00" + ":" + "00" + ":" + "00",
          this.DateParameter[1] + " " + "23" + ":" + "59" + ":" + "59",
        ];
      }
      this.allPageFormInlineChange();
    },
    //订单列表切换页码
    otCurrentChange(newPage) {
      this.$set(this.formInline, "pageNo", newPage);
      this.getOrderList();
    },
    handleSizeChange(newSize) {
      this.$set(this.formInline, "pageSize", newSize);
      this.getOrderList();
    },
    // 订单列表
    getOrderList() {
      if (this.formInline.queryMember) {
        this.parmsTemp = {
          ...this.formInline,
          queryMember: this.queryMemberTemp,
        };
      } else {
        this.parmsTemp = { ...this.formInline };
      }

      if (this.DateParameter && this.DateParameter.length > 0) {
        this.$set(this.parmsTemp, "startDate", this.DateParameter[0]);
        this.$set(this.parmsTemp, "endDate", this.DateParameter[1]);
      }
      getOrderList(this.parmsTemp).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          }
          this.orderDataObj = res.data.result;
          this.orderData = res.data.result.records;
          this.orderTotle = res.data.result.total;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 打开创建订单
    openCreateOrderDialog() {
      this.createOrderDialog = true;
      this.createDateNow = dateNow();
      this.getHonourList();
    },
    // 创建订单搜索会员名称/电话
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          getMembersInfo({ queryValue: query }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.dimMemberList = res.data.result;
            }
          });
        }, 200);
      } else {
        this.dimMemberList = [];
      }
    },
    // 根据id查找会员  回显
    pitchMember() {
      getMemberById({ id: this.createOrderFrom.memberId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.$set(
            this.createOrderFrom,
            "memberName",
            res.data.result.memberName
          );
          this.$set(
            this.createOrderFrom,
            "memberPhone",
            res.data.result.memberMobile
          );
          this.$set(
            this.createOrderFrom,
            "createUserName",
            res.data.result.createUserName
          );
          this.$set(this.createOrderFrom, "shopName", res.data.result.shopName);
          this.createOrderFrom.editHonours = res.data.result.honourIds
            ? res.data.result.honourIds.split(",")
            : [];
          this.createOrderFrom.photoData = res.data.result.photoData;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 添加订单
    addOrders() {
      console.log("添加订单", this);
      this.$refs["createOrderFrom"].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          addOrder({
            memberId: this.createOrderFrom.memberId,
            createUser: this.createOrderFrom.createUser,
            numberOfShoppers: this.createOrderFrom.numberOfShoppers,
          })
            .then((res) => {
              if (res.status === 200 && res.data.success) {
                this.$message({
                  message: "创建成功",
                  type: "success",
                });
                this.createOrderDialogClose();
                this.getOrderList();
              } else {
                this.$message.error(res.data.message);
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        }
      });
    },
    // 关闭创建订单
    createOrderDialogClose() {
      this.createOrderDialog = false;
      this.createOrderFrom.photoData = "";
      this.dimMemberList = [];
      this.$refs["createOrderFrom"].resetFields();
    },
    // 创建会员
    openCreateVipDialog(type) {
      this.createOrUp = type;
      this.createVipDialog = true;
      if (type == "up") {
        this.upgradeCardFlag = true;
        this.huixian = this.memberInfo.antOrderMiscellaneousList;
      }
    },
    // 关闭子组件创建会员弹窗
    input() {
      this.getOrderList();
    },
    // 成绩录入关闭弹窗
    inputGradeInClose(val) {
      this.gradeInDialog = val;
      this.getOrderList();
    },
    // 比赛录入关闭弹窗
    pkInDialogClose(val) {
      this.pkInDialog = val;
      this.getOrderList();
    },
    // 订单详情
    openOrderDetails(row) {
      this.orderDetails = true;
      this.orderId = row.id;
    },
    // 成绩录入
    openGradeInDialog(row) {
      this.memberId = row.memberId;
      this.orderId = row.id;
      this.memberPoints = row.memberPoints;
      this.gradeInDialog = true;
    },
    // 比赛录入
    openPkInDialog(row) {
      this.memberId = row.memberId;
      this.orderId = row.id;
      this.pkInDialog = true;
    },
    // 订单结算打开弹窗
    openOrderOverDialog(row) {
      // 清缓存
      (this.specialItem = [
        {
          dictKey: "upgrade_card",
          name: "升卡",
          money: "",
          upgradeLevelId: "",
          remarks: "",
        },
        {
          dictKey: "stored_value",
          name: "储值",
          money: "",
          remarks: "",
        },
        {
          dictKey: "drinks",
          name: "饮料",
          money: "",
          remarks: "",
        },
        {
          dictKey: "settlementNotByMembershipLevel",
          name: "储赠扣款",
          money: "",
          remarks: "",
        },
      ]),
        (this.orderOverDialog = true);
      this.createDateNow = dateNow();
      this.orderId = row.id;
      getOrderDetail({ id: row.id }).then((res) => {
        if (res.status === 200 && res.data.success) {
          // memberInfo是订单详情
          this.memberInfo = res.data.result;
          this.memberId = this.memberInfo.memberId;
          this.memberInfo.antOrderTempList = [];
          if (this.memberInfo.antOrderMiscellaneousList) {
            this.specialItem.map((item) => {
              if (
                !this.contains(this.memberInfo.antOrderMiscellaneousList, item)
              ) {
                this.memberInfo.antOrderTempList.push(item);
              }
            });
            this.memberInfo.antOrderMiscellaneousList.map((itm) => {
              if (itm.name == "升卡") {
                this.getMembersCardLevelSelect(itm.upgradeLevelId);
              }
            });
          } else {
            this.memberInfo.antOrderTempList = this.specialItem;
          }
        } else {
          this.$message.error("操作失败,稍后再试");
        }
      });
    },
    // 订单结算添加其他费用弹窗打开
    openAddOtherDialog() {
      this.showSubtraction = true; //显示减号
      this.addOtherDialog = true; //打开弹窗
      // 回显之前的选中项
      if (this.memberInfo.antOrderMiscellaneousList) {
        this.memberInfo.antOrderMiscellaneousList.map((item) => {
          this.check.map((itm) => {
            if (itm.name == item.name) {
              itm.checked = true;
            }
          });
        });
      }
    },
    // 添加其他费用确定
    melfDialog() {
      this.addOtherDialog = false;
      let arr = this.check;
      // console.log(this.memberInfo.antOrderMiscellaneousList);
      if (this.memberInfo.antOrderMiscellaneousList) {
        const temps = {};
        this.memberInfo.antOrderMiscellaneousList.forEach((ele) => {
          temps[ele.name] = ele.money;
        });
        // console.log(temps);
        arr.map((item) => {
          if (item.checked) {
            if (
              !this.contains(this.memberInfo.antOrderMiscellaneousList, item)
            ) {
              // console.log(item);
              this.memberInfo.antOrderMiscellaneousList.push({
                name: item.name,
                money: temps[item.name],
              });
            }
          }
        });
      } else {
        this.memberInfo.antOrderMiscellaneousList = [];
        arr.map((item) => {
          if (item.checked) {
            this.memberInfo.antOrderMiscellaneousList.push({
              name: item.name,
              money: "",
            });
          }
        });
      }
      arr.map((it) => {
        if (!it.checked)
          this.spliceItem(this.memberInfo.antOrderMiscellaneousList, it);
      });
    },
    // 避免重复添加
    contains(arr, obj) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].name === obj.name) {
          return true;
        }
      }
      return false;
    },
    // 取消 this.check勾选时，订单页面取消当前项
    spliceItem(arr, obj) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].name === obj.name) {
          this.memberInfo.antOrderMiscellaneousList.splice(i, 1);
        }
      }
    },
    // 订单结算删除其他费用
    remoteOther(item) {
      let index = this.memberInfo.antOrderMiscellaneousList.indexOf(item);
      if (index !== -1) {
        this.memberInfo.antOrderMiscellaneousList.splice(index, 1);
      }
      //  删除自定义费用选中
      this.check.map((itm) => {
        if (item.name == itm.name) {
          itm.checked = false;
        }
      });
    },

    // 订单结算添加其他费用弹窗关闭
    addOtherDialogClose() {
      this.addOtherDialog = false;
    },
    // 订单保存
    addOrderDetails() {
      let memberInfoParam = { ...this.memberInfo };
      if (memberInfoParam.antOrderMiscellaneousList) {
        memberInfoParam.antOrderMiscellaneousList =
          memberInfoParam.antOrderMiscellaneousList.concat(
            this.memberInfo.antOrderTempList
          );
      } else {
        memberInfoParam.antOrderMiscellaneousList =
          this.memberInfo.antOrderTempList;
      }
      memberInfoParam.antOrderMiscellaneousList =
        memberInfoParam.antOrderMiscellaneousList.filter((item) => {
          return item.money && item.money != "";
        });
      if (
        memberInfoParam.antOrderMiscellaneousList &&
        memberInfoParam.antOrderMiscellaneousList.length > 0
      ) {
        memberInfoParam.antOrderMiscellaneousList.map((item) => {
          if (item.name == "退款") {
            item.dictKey = "refund_deposit";
          }
        });
      }
      // console.log(memberInfoParam.antOrderMiscellaneousList);
      addOrderDetails(memberInfoParam).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.orderOverDialogClose();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 订单结算弹窗关闭
    orderOverDialogClose() {
      this.orderOverDialog = false;
      this.upgradeCardFlag = false;
      this.showSubtraction = false;
      this.upafter = "";
      this.check.map((item) => {
        item.checked = false;
      });
      this.getOrderList();
    },
    // 取消订单弹窗打开
    openCancelOrderDialog(row) {
      this.cancelOrderDialog = true;
      this.orderId = row.id;
      this.cancelReason = row.remarks;
    },
    //  取消订单弹窗关闭
    cancelOrderDialogClose() {
      this.cancelOrderDialog = false;
      this.cancelReason = "";
    },
    // 取消订单
    cancelOrder() {
      cancelOrder({ id: this.orderId, remarks: this.cancelReason }).then(
        (res) => {
          if (res.status === 200 && res.data.success) {
            this.$message({
              message: "取消成功",
              type: "success",
            });
            this.cancelOrderDialogClose();
            this.getOrderList();
          } else {
            this.$message.error(res.data.message);
          }
        }
      );
    },
    // 回显升卡后所差价,升卡后的会员等级id,升卡后等级,储值
    prices(price, levelId, afterLevelIdName, balance) {
      this.upafter = afterLevelIdName;
      if (
        this.memberInfo.antOrderTempList &&
        this.memberInfo.antOrderTempList.length > 0
      ) {
        this.memberInfo.antOrderTempList.map((item) => {
          if (item.name == "升卡") {
            item.money = price;
            item.upgradeLevelId = levelId;
          } else if (item.name == "储值") {
            item.money = balance;
          }
        });
      }
      if (
        this.memberInfo.antOrderMiscellaneousList &&
        this.memberInfo.antOrderMiscellaneousList.length > 0
      ) {
        this.memberInfo.antOrderMiscellaneousList.map((item) => {
          if (item.name == "升卡") {
            item.money = price;
            item.upgradeLevelId = levelId;
          } else if (item.name == "储值") {
            item.money = balance;
          }
        });
      }
    },
    // 订单结算弹窗  点击结算弹窗
    openOrderOverDetailsDialog() {
      this.orderOverDetailsDialog = true;
      this.chuzhiandzengchu = 0;
      this.xx = 0;
      // 没有办法判断该订单是否有修改  只能是每一次点结算都先保存一下
      let memberInfoParam = { ...this.memberInfo };
      if (memberInfoParam.antOrderMiscellaneousList) {
        memberInfoParam.antOrderMiscellaneousList =
          memberInfoParam.antOrderMiscellaneousList.concat(
            this.memberInfo.antOrderTempList
          );
      } else {
        memberInfoParam.antOrderMiscellaneousList =
          this.memberInfo.antOrderTempList;
      }
      memberInfoParam.antOrderMiscellaneousList =
        memberInfoParam.antOrderMiscellaneousList.filter((item) => {
          return item.money && item.money != "";
        });
      if (
        memberInfoParam.antOrderMiscellaneousList &&
        memberInfoParam.antOrderMiscellaneousList.length > 0
      ) {
        memberInfoParam.antOrderMiscellaneousList.map((item) => {
          if (item.name == "退款") {
            item.dictKey = "refund_deposit";
          }
        });
      }
      // console.log(memberInfoParam);
      addOrderDetails(memberInfoParam).then((res) => {
        if (res.status === 200 && res.data.success) {
          //保存成功后 根据id返回结算信息
          getsettlementReturnsBillingInformation({ id: this.orderId }).then(
            (res) => {
              // console.log(res, "结算信息");
              if (res.status === 200 && res.data.success) {
                this.closeMoney = res.data.result;
                // 应结算=总计金额
                this.closeMoney.residue = this.closeMoney.totalMoney * 1;
                // 会员抵扣为0
                this.closeMoney.realityMoney = 0;
                //  射箭总数
                this.playNum =
                  this.closeMoney.archeryNumber * 1 +
                  this.closeMoney.followArcheryNumber * 1;
                // console.log(this.playNum);
                // 需要判断 箭票 电子卡 储值 增储是否为0 如果为0 禁用按钮
                if (!this.closeMoney.balance) {
                  this.disstoredValue = true; //储值
                }
                if (!this.closeMoney.arrowVolume) {
                  // console.log(this.closeMoney.arrowVolume);
                  this.disjianpiao = true; //箭票
                }
                if (!this.closeMoney.giveStore) {
                  this.disgive = true; //赠储;
                }
                if (!this.closeMoney.electronicCard) {
                  this.discard = true; //电子卡
                }
                //如果没射箭 除了饮料都需要禁用
                if (
                  this.closeMoney.archeryNumber * 1 +
                    this.closeMoney.followArcheryNumber * 1 ==
                  0
                ) {
                  this.disstoredValue = true;
                  this.disjianpiao = true;
                  this.disgive = true;
                  this.discard = true;
                  this.disyouzanjianpiao = true;
                  this.diszhizhijianpiao = true;
                  this.disyouzancard = true;
                }
                //如果没消费饮料  饮料也需要禁用
                // console.log(this.closeMoney.antOrderMiscellaneousList);
                if (
                  this.closeMoney.antOrderMiscellaneousList &&
                  this.closeMoney.antOrderMiscellaneousList.length > 0
                ) {
                  this.closeMoney.antOrderMiscellaneousList.map((item) => {
                    if (item.dictKey == "drinks") {
                      this.drinksmoney = item.money;
                      this.havedrink = true;
                      // item.max = item.money;
                      this.storedPaymentMethodList[2].max = item.money;
                    } else {
                      this.storedPaymentMethodList.forEach((ele, index) => {
                        if (index != 2) {
                          ele.max = this.playNum;
                        }
                      });
                      this.arrowPaymentMethodList.forEach((ele) => {
                        ele.max = this.playNum;
                      });
                    }
                  });
                  if (!this.havedrink) {
                    this.disdrinks = true;
                  }
                } else {
                  this.disdrinks = true;
                }
              } else {
                this.$message.error(res.data.message);
              }
              this.storedPaymentMethodList.forEach((ele, index) => {
                if (index != 2) {
                  ele.max = this.playNum;
                }
              });
              this.arrowPaymentMethodList.forEach((ele) => {
                ele.max = this.playNum;
              });
            }
          );
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    disbchange() {
      this.disb = !this.disb;
    },
    convertNumber(arg1) {
      const str = arg1.toString();
      let before, after, r1, m;
      if (str.indexOf(".") > -1) {
        before = arg1.toString().split(".")[0];
        after = arg1.toString().split(".")[1];
      } else {
        before = str;
        after = "0";
      }
      after = after.padEnd(2, 0);
      //beishu = Math.pow(10, after.length);
      return parseInt(before * 100 + after * 1);
    },
    // 订单结算弹窗关闭
    orderOverDetailsDialogClose() {
      this.orderOverDetailsDialog = false;
      this.disstoredValue = false;
      this.disjianpiao = false;
      this.disgive = false;
      this.discard = false;
      this.disyouzanjianpiao = false;
      this.diszhizhijianpiao = false;
      this.disyouzancard = false;
      this.disdrinks = true;
      this.otherPay = 0;
      this.arrowPaymentMethodList.forEach((item) => {
        item.payMoney = "";
      });
      this.otherPaymentMethodList.forEach((item) => {
        item.payMoney = "";
      });
      this.storedPaymentMethodList.forEach((item) => {
        item.payMoney = "";
      });
      this.otherArr.forEach((item) => {
        item.payMoney = "";
      });
    },
    changeMoey(currentValue, oldValue, everyList) {
      if (
        everyList.paymentMethod == "arrow_ticket" &&
        everyList.payMoney == this.closeMoney.arrowVolume
      ) {
        this.$message({
          message: "温馨提示：箭票剩余不足",
          type: "warning",
        });
      }
      if (
        everyList.paymentMethod == "electronic_card" &&
        everyList.payMoney == this.closeMoney.electronicCard
      ) {
        this.$message({
          message: "温馨提示：电子卡剩余不足",
          type: "warning",
        });
      }
      //储值射箭   balance_consume   随行储值消费  follow_balance_consume
      if (
        everyList.paymentMethod == "balance_consume" ||
        everyList.paymentMethod == "follow_balance_consume"
      ) {
        // num1 储值消费抵扣组数   num2 随行储值消费抵扣组数  storedValue 一共抵扣金额
        let num1 = this.storedPaymentMethodList[0].payMoney
          ? this.storedPaymentMethodList[0].payMoney
          : 0;
        let num2 = this.storedPaymentMethodList[3].payMoney
          ? this.storedPaymentMethodList[0].payMoney
          : 0;
        let storedValue =
          num1 * this.closeMoney.levelPrice +
          num2 * this.closeMoney.followPrice;
        if (storedValue > this.closeMoney.balance) {
          this.$message({
            message: "温馨提示：储值不足",
            type: "warning",
          });
        }
      }
      //赠储消费  give_store_consume   随行储值消费 follow_balance_consume
      if (
        everyList.paymentMethod == "give_store_consume" ||
        everyList.paymentMethod == "follow_balance_consume"
      ) {
        // num3 赠储消费抵扣组数   num4 随行赠储消费抵扣组数  giveStoredValue 一共抵扣金额
        let num3 = this.storedPaymentMethodList[1].payMoney
          ? this.storedPaymentMethodList[1].payMoney
          : 0;
        let num4 = this.storedPaymentMethodList[4].payMoney
          ? this.storedPaymentMethodList[4].payMoney
          : 0;
        let giveStoredValue =
          num3 * this.closeMoney.levelPrice +
          num4 * this.closeMoney.followPrice;
        if (giveStoredValue > this.closeMoney.giveStore) {
          this.$message({
            message: "温馨提示：赠储不足",
            type: "warning",
          });
        }
      }
      // ------------------------------------------------------------------------------
      // 饮料消费 drinks_consume   储值 balance   饮料消费金额 drinksmoney  饮料input的值 changeDrinkMoney
      if (everyList.paymentMethod == "drinks_consume") {
        if (everyList.payMoney < this.closeMoney.balance) {
          if (everyList.payMoney == this.drinksmoney) {
            this.$message({
              message: "温馨提示：饮料消费抵扣完成",
              type: "warning",
            });
            this.changeDrinkMoney = everyList.payMoney;
          } else {
            this.changeDrinkMoney = everyList.payMoney;
          }
        } else {
          //  这个提示不准 因为拿不到实时储值（就是在页面抵扣了储值后的储值）
          this.$message({
            message: "温馨提示：储值余额不足",
            type: "warning",
          });
        }
      } else {
        // 禁用加号相关代码
        const tmpDatas = this.storedPaymentMethodList.concat(
          this.arrowPaymentMethodList
        );
        let otherTotal = 0;
        tmpDatas.forEach((ele) => {
          if (ele.text != "饮料消费" && everyList.text != ele.text) {
            otherTotal += ele.payMoney * 1;
            // console.log(otherTotal);
          }
        });
        this.storedPaymentMethodList.forEach((ele) => {
          if (ele.text != "饮料消费" && everyList.text != ele.text) {
            ele.max = this.playNum - currentValue - otherTotal + ele.payMoney;
          }
        });
        this.arrowPaymentMethodList.forEach((ele) => {
          if (everyList.text != ele.text) {
            ele.max = this.playNum - currentValue - otherTotal + ele.payMoney;
          }
        });
      }
      // ------------------------------------------------------------------------------
      let arrParm = [];
      //初始化一下 抵扣总数（组）(箭票射箭+储值消费（不算饮料）抵扣的总组数)
      this.playAll = 0;
      arrParm = this.arrowPaymentMethodList.concat(
        this.storedPaymentMethodList
      );
      arrParm.filter((item) => {
        if (item.payMoney && item.paymentMethod != "drinks_consume") {
          this.playAll += item.payMoney * 1;
        }
      });
      if (everyList.paymentMethod != "drinks_consume") {
        if (
          this.playAll ==
            this.closeMoney.archeryNumber * 1 +
              this.closeMoney.followArcheryNumber * 1 &&
          this.playAll != 0
        ) {
          this.$message({
            message: "抵扣完成，不可继续进行抵扣",
            type: "warning",
          });
        }
      }
      // 随行储值消费 follow_balance_consume  随行赠储消费  follow_give_store_consume
      // if (
      //   everyList.paymentMethod == "follow_balance_consume" ||
      //   everyList.paymentMethod == "follow_give_store_consume"
      // ) {
      //   let followbalance = this.storedPaymentMethodList[3].payMoney
      //     ? this.storedPaymentMethodList[3].payMoney
      //     : 0;
      //   let followgive = this.storedPaymentMethodList[4].payMoney
      //     ? this.storedPaymentMethodList[4].payMoney
      //     : 0;
      //   if (
      //     followbalance * 1 + followgive * 1 >=
      //     this.memberInfo.followArcheryNumber
      //   ) {
      //     this.$message({
      //       message: "随行射箭抵扣完成，不可继续进行抵扣",
      //       type: "warning",
      //     });
      //   }
      // }
      // -------------------------------------------------------------
      // 计算抵扣金额
      // 储值射箭[0]  赠储消费[1] 随行储值消费[3]  随行赠储消费[4] 箭票射箭数组总抵扣数arrowPayGroup
      let storedValueGroup = this.storedPaymentMethodList[0].payMoney;
      let giftSavingsGroup = this.storedPaymentMethodList[1].payMoney;
      let followBalanceConsume = this.storedPaymentMethodList[3].payMoney;
      let followGiveStoreConsume = this.storedPaymentMethodList[4].payMoney;
      let arrowPayGroup = 0;
      this.arrowPaymentMethodList.filter((item) => {
        if (item.payMoney) {
          arrowPayGroup += item.payMoney * 1;
        }
      });
      if (
        followBalanceConsume * 1 + followGiveStoreConsume * 1 >
        this.memberInfo.followArcheryNumber
      ) {
        this.$message({
          message: "当前随行储值消费和随行赠储消费数不能大于随行射箭组数！",
          type: "warning",
        });
      } else if (
        storedValueGroup * 1 + giftSavingsGroup * 1 >
        this.memberInfo.archeryNumber
      ) {
        this.$message({
          message: "当前储值消费和赠储消费数不能大于会员射箭组数！",
          type: "warning",
        });
      } else {
        // stepA（会员剩余组数） =  会员射箭组数-（储值消费组数+赠储消费组数）
        let stepA =
          this.memberInfo.archeryNumber * 1 -
          (storedValueGroup * 1 + giftSavingsGroup * 1);
        // stepB（随行剩余组数） =  随行射箭组数-（随行储值消费组数+随行赠储消费组数）
        let stepB =
          this.memberInfo.followArcheryNumber * 1 -
          (followBalanceConsume * 1 + followGiveStoreConsume * 1); //随行剩余组数
        // stepX  会员剩余组数-箭票数组支付数量
        let stepX = stepA - arrowPayGroup;
        if (stepX > 0) {
          //1、会员未支付完  xx是抵扣的钱(不算饮料的抵扣)
          // 会员未支付完 就是会员没有全部抵扣  arrowPayGroup数组都是给会员抵扣的
          // 抵扣总金额=会员被抵扣数*会员单价+随行被抵扣数*随行单价+饮料抵扣
          //realityMoney=(arrowPayGroup+storedValueGroup+giftSavingsGroup)*this.memberInfo.levelPrice+ (followBalanceConsume + followGiveStoreConsume) *this.memberInfo.followPrice+ this.changeDrinkMoney * 1;
          this.xx =
            (this.memberInfo.archeryNumber - stepX) *
              this.memberInfo.levelPrice +
            (followBalanceConsume + followGiveStoreConsume) *
              this.memberInfo.followPrice;
          // this.closeMoney.realityMoney =
          //   (this.convertNumber(xx) +
          //     this.convertNumber(this.changeDrinkMoney)) /
          //     100
          // this.closeMoney.residue =
          //   (this.convertNumber(this.closeMoney.totalMoney) -
          //     this.convertNumber(this.closeMoney.realityMoney)) /
          //   100;
          this.yaofengle();
        } else if (stepX == 0) {
          //2、会员刚好支付完成  就是会员射箭刚好全部抵扣
          // 抵扣总金额=会员射箭消费金额+随行被抵扣数*随行单价+饮料抵扣
          // realityMoney=this.closeMoney.archeryPriceTotal+(followBalanceConsume + followGiveStoreConsume) *this.memberInfo.followPrice+ this.changeDrinkMoney * 1;
          this.xx =
            this.closeMoney.archeryPriceTotal +
            (followBalanceConsume + followGiveStoreConsume) *
              this.memberInfo.followPrice;
          // this.closeMoney.realityMoney =
          //   (this.convertNumber(xx) +
          //     this.convertNumber(this.changeDrinkMoney)) /
          //   100;
          // this.closeMoney.residue =
          //   (this.convertNumber(this.closeMoney.totalMoney) -
          //     this.convertNumber(this.closeMoney.realityMoney)) /
          //   100;
          this.yaofengle();
        } else {
          //3、 会员支付完成 且有剩余支付随行  stepX小于0   stepX的绝对值=就是抵扣会员后剩余的组数=抵扣随行的(不包括随行储值消费和随性赠储消费)
          // 随行没有被支付完
          // 抵扣总金额=会员射箭消费金额+随行被抵扣数(箭票消费数组抵扣+随行储值消费抵扣+随性赠储消费抵扣)*随行单价+饮料抵扣
          if (Math.abs(stepX) - stepB != 0) {
            this.xx =
              this.closeMoney.archeryPriceTotal +
              (Math.abs(stepX) +
                followBalanceConsume +
                followGiveStoreConsume) *
                this.memberInfo.followPrice;
            // this.closeMoney.realityMoney =
            //   (this.convertNumber(xx) +
            //     this.convertNumber(this.changeDrinkMoney)) /
            //   100;
            // this.closeMoney.residue =
            //   (this.convertNumber(this.closeMoney.totalMoney) -
            //     this.convertNumber(this.closeMoney.realityMoney)) /
            //   100;
            this.yaofengle();
          } else {
            // ==0    全部支付完成
            this.closeMoney.realityMoney =
              (this.convertNumber(this.closeMoney.archeryPriceTotal) +
                this.convertNumber(this.closeMoney.followPriceTotal) +
                this.convertNumber(this.changeDrinkMoney)) /
              100;
            this.closeMoney.residue =
              (this.convertNumber(this.closeMoney.totalMoney) -
                this.convertNumber(this.closeMoney.realityMoney)) /
              100;
          }
        }
      }
    },
    // 订单结算
    orderOverDetailsDialogCloses() {
      // if (
      //   this.storedPaymentMethodList[0].payMoney > this.closeMoney.archeryNumber
      // ) {
      //   this.$message({
      //     message: "储值消费组数大于会员射箭组数,不可进行消费",
      //     type: "warning",
      //   });
      //   return;
      // }
      // if (
      //   this.storedPaymentMethodList[3].payMoney >
      //   this.closeMoney.followArcheryNumber
      // ) {
      //   this.$message({
      //     message: "随行储值消费组数大于随行射箭组数,不可进行消费",
      //     type: "warning",
      //   });
      //   return;
      // }
      // arrowPaymentMethodList箭票消费
      // storedPaymentMethodList储值消费
      // otherPaymentMethodList其他结算方式
      let arrowArr = this.arrowPaymentMethodList.filter((item) => {
        if (item.payMoney != "") {
          return item;
        }
      });
      let storedArr = this.storedPaymentMethodList.filter((item) => {
        if (item.payMoney != "") {
          return item;
        }
      });
      let otherArrPay = this.otherPaymentMethodList.filter((item) => {
        if (item.payMoney != "") {
          return item;
        }
      });
      let storeArr = this.otherArr.filter((item) => {
        if (item.payMoney != "") {
          return item;
        }
      });
      this.disabledClose = true;
      const loadingOver = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      confirmPayment({
        ...this.closeMoney,
        otherPaymentMethodList: otherArrPay,
        arrowPaymentMethodList: arrowArr,
        storedPaymentMethodList: storedArr,
        storedBalancePaymentMethodList: storeArr,
      })
        .then((res) => {
          this.disabledClose = false;
          loadingOver.close();
          if (res.status === 200 && res.data.success) {
            this.$message({
              message: "结算成功",
              type: "success",
            });
            this.orderOverDetailsDialogClose();
            this.orderOverDialogClose();
          } else {
            this.$alert(
              "<strong style='font-size:16px;color:red'>" +
                res.data.message +
                "</strong>",
              "提示您",
              {
                dangerouslyUseHTMLString: true,
              }
            );
          }
        })
        .catch((err) => {
          loadingOver.close();
        });
    },
    hah() {
      this.$forceUpdate();
    },
    //获取会员等级下拉--匹配升卡汉字
    getMembersCardLevelSelect(upafterNames) {
      getMembersCardLevelSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          res.data.result.map((itm) => {
            if (itm.id == upafterNames) {
              this.upafter = itm.cardName;
            }
          });
        }
      });
    },
    dateNowYearPage() {
      // 日期默认当天
      this.DateParameter = [
        dateNowYear() + " " + "00" + ":" + "00" + ":" + "00",
        dateNowYear() + " " + "23" + ":" + "59" + ":" + "59",
      ];
    },
    reset() {
      this.formInline.orderStatus = "";
      this.$refs["ruleForm"].resetFields();
      this.dateNowYearPage();
      this.allPageFormInlineChange();
    },
    onChangeMoney() {
      // this.otherPay = this.otherPaymentMethodList.reduce(function (prev, cur) {
      //   // 如果輸入减号 值按0计算
      //   return prev + (cur.payMoney == "-" ? 0 : cur.payMoney) * 1;
      // }, 0);
      // console.log(this.otherPay);
      this.otherPay = 0;
      this.otherPaymentMethodList.map((item) => {
        this.otherPay += this.convertNumber(
          item.payMoney == "-" ? 0 : item.payMoney
        );
      });
      this.otherPay = this.otherPay / 100;
    },
    // 获取自定义项
    getOrderCustomizationList() {
      getOrderCustomizationList().then((res) => {
        res.data.result.forEach((itm) => {
          itm.checked = false;
        });
        this.check = res.data.result;
      });
    },
    //荣誉列表
    getHonourList() {
      getHonourList().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.vipHonor = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    openMember(row) {
      this.gopenMemberDialogmemberId = row.memberId;
      this.gopenMemberDialog = true;
    },
    gopenMemberDialogClose(val) {
      this.gopenMemberDialog = val;
    },
    delorder(row) {
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delorder({ id: row.id }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.$message.success("删除成功");
              this.getOrderList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    inputOtherArr() {
      this.chuzhiandzengchu = 0;
      this.otherArr.map((item) => {
        this.chuzhiandzengchu += this.convertNumber(
          item.payMoney == "-" ? 0 : item.payMoney
        );
      });
      this.chuzhiandzengchu = this.chuzhiandzengchu / 100;
      this.yaofengle();
    },
    yaofengle() {
      this.closeMoney.realityMoney = 0;
      // 所有箭票抵扣+储值赠储消费的和+饮料抵扣=总抵扣
      this.closeMoney.realityMoney =
        (this.convertNumber(this.xx) +
          this.convertNumber(this.changeDrinkMoney)) /
          100 +
        this.chuzhiandzengchu * 1;
      this.closeMoney.residue =
        (this.convertNumber(this.closeMoney.totalMoney) -
          this.convertNumber(this.closeMoney.realityMoney)) /
        100;
    },
  },
};
</script>

<style scoped>
.flexOney {
  display: flex;
}
.colorRed {
  color: red;
}
.colorBlue {
  color: #409eff;
}
.mb15 {
  margin-bottom: 15px;
}
.ml20 {
  margin-left: 20px;
}
.ml10 {
  margin-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.underline {
  border-bottom: 1px solid #ccc;
}
.positionR {
  position: relative;
}
.width70 {
  width: 70%;
}
.width70 .el-input {
  width: 55%;
}
.inMan .el-input {
  width: 15%;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.orderMain {
  padding: 30px;
}
.orderTotle {
  font-size: 18px;
  font-weight: 700;
}
.btnClass {
  margin-right: 20px;
  margin-bottom: 10px;
}
.flexTitle {
  font-size: 16px;
  padding: 10px 10px 20px 18px;
  display: flex;
  justify-content: space-between;
}
.oederManPhoto {
  position: absolute;
  width: 140px;
  height: 140px;
  top: 30px;
  right: 30px;
}
.borderB {
  padding-left: 18px;
  border-bottom: 1px solid #ccc;
}
.pageClass {
  margin: 30px 10px;
}
.oederManPhoto img {
  width: 100%;
  height: 100%;
}
.addOther {
  position: absolute;
  top: 5px;
  right: 10px;
}
.ortherClass {
  position: relative;
  height: 40px;
  line-height: 35px;
}
.checkBox {
  display: flex;
  flex-wrap: wrap;
}
.checkBox > div {
  margin-left: 25px;
}
.vipclearing {
  margin-left: 60px;
  display: flex;
  margin-bottom: 15px;
}
.clearingBox {
  display: flex;
  flex-wrap: wrap;
  margin-left: 50px;
}
.clearingBox > div {
  width: 30%;
}
.clearingBoxs {
  display: flex;
  flex-wrap: wrap;
}
.clearingBoxs > div {
  width: 30%;
  margin-left: 20px;
  margin-bottom: 10px;
}
.disFWrap {
  margin-left: 50px;
  display: flex;
  flex-wrap: wrap;
}
.disF {
  width: 45%;
  display: flex;
  margin-left: 10px;
}
.tags {
  width: 15%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.inputbox {
  width: 60%;
  margin-left: 10px;
}
.inputbox .el-input {
  width: 85%;
  margin-left: 5px;
}
.ml45 {
  margin-left: 45px;
}
.ml5 {
  margin-left: 5px;
}
.right {
  width: 140px;
  height: 140px;
  margin-right: 30px;
}
.right img {
  width: 100%;
  height: 100%;
}
.needwidth1 {
  display: inline-block;
  width: 75px;
}
.needwidth {
  display: inline-block;
  width: 90px;
}
.fz {
  margin-bottom: 15px;
  font-size: 700;
}
.mb25 {
  margin-bottom: 25px;
}
.disflexOne {
  display: flex;
}
/* .pr {
  padding-right: 20px;
} */
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner {
  width: 300px;
}
.iconClass {
  position: relative;
  top: 13px;
}
.remaaaaa {
  width: 60px;
  margin-left: 10px;
}
.width50 {
  width: 100px;
}
</style>
